
import ConversationStatus from '@/models/Conversations/ConversationStatus';
import AgencyUserDto from '../AgencyUsers/AgencyUserDto';

export default class CurrentConversationSearchCriteria {
    selectedAssignedTo: AgencyUserDto = null;
    selectedStatus: ConversationStatus = ConversationStatus.WorkerWaiting;
}